import { TEMPLATE_PROPS } from '../constants'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      searchKey: '',
      suggestions: []
    }
  },
  computed: {
    filteredTemplates() {
      // if (!this.searchKey) return this.data
      // return this.data.filter(item =>
      //   item[TEMPLATE_PROPS.LABEL] && item[TEMPLATE_PROPS.LABEL].indexOf(this.searchKey) !== -1
      // )
      return this.data
    }
  },
  methods: {
    handleSearchInput(val) {
      this.searchKey = val
    },
    handleSearchSelect(item) {
      if (item) {
        const index = this.filteredTemplates.findIndex(v => item[TEMPLATE_PROPS.BATCH_ID] === v[TEMPLATE_PROPS.BATCH_ID])
        this.handleChange(index)
        this.searchKey = ''
      }
    },
    querySearch(queryString, cb) {
      let results = []
      if (!this.filteredTemplates.length || !queryString || queryString.length < 2) {
        cb(results)
        return
      }
      results = this.filteredTemplates.filter(v => v[TEMPLATE_PROPS.LABEL] && v[TEMPLATE_PROPS.LABEL].includes(queryString))
      cb(results)
      // 自动选择第一行
      this.$nextTick(_ => {
        results.length && this.$refs.templateInput.highlight && this.$refs.templateInput.highlight(0)
      })
    },
    handleChange(index) {
      this.$emit('change', index)
    },
    handleEdit(index) {
      this.$emit('edit', index)
    },
    handleDelete(index) {
      this.$emit('delete', index)
    }
  },
  render() {
    const { filteredTemplates, activeId } = this
    const wrapClass = 'kye-field-settings-template-panel'
    const searchClass = `${wrapClass}-search`
    const listClass = `${wrapClass}-list`
    const itemClass = `${wrapClass}-item`
    const itemNameClass = `${itemClass}-name`
    const actionClass = `${itemClass}-action`
    const emptyClass = `${wrapClass}-empty`

    return (
      <div class={wrapClass}>
        <div class={searchClass}>
          <el-autocomplete
            ref="templateInput"
            value={this.searchKey}
            value-key={TEMPLATE_PROPS.LABEL}
            onInput={this.handleSearchInput}
            onSelect={this.handleSearchSelect}
            fetch-suggestions={this.querySearch}
            placeholder="搜索模板名称"
            clearable
          >
            <i slot="prefix" class="layout layout-search"></i>
          </el-autocomplete>
        </div>
        <div
          class={{
            [listClass]: true,
            'kye-scrollbar': true
          }}>
          {filteredTemplates.map((template, idx) => (
            <div
              key={template[TEMPLATE_PROPS.BATCH_ID]}
              class={{
                [itemClass]: true,
                'is-active': activeId === template[TEMPLATE_PROPS.BATCH_ID]
              }}
              onClick={() => this.handleChange(idx)}
            >
              <span class={itemNameClass}>{template[TEMPLATE_PROPS.LABEL]}</span>
              {activeId === template[TEMPLATE_PROPS.BATCH_ID] && (
                <div class={actionClass}>
                  <i class="el-icon-edit" onClick={() => this.handleEdit(idx)}></i>
                  <i class="el-icon-delete red" onClick={() => this.handleDelete(idx)}></i>
                </div>
              )}
            </div>
          ))}
          {filteredTemplates.length === 0 && (
            <kye-empty class={emptyClass} imageSize={100}></kye-empty>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/components/template-panel.js